import classNames from 'classnames';
import React, { useRef, useState } from 'react';
import { Button } from 'src/common/button';
import { promiseDelay } from 'src/common/helpers/promise-delay';
import { NeueJourneyLoadingSpinner } from 'src/editor/content-creation/components/loading/journey-spinner';
import { MiniModal } from 'src/editor/content-creation/components/mini-modal';
import { NeueJourneyButton } from 'src/editor/content-creation/components/neue-button/journey';
import { functionNoop } from 'src/utils/function/noop';

export const AccountDeactiveWidget = ({ onAcceptClick }: { onAcceptClick: () => Promise<void> }) => {
  const [loading, setLoading] = useState(false);
  const modalOpenRef = useRef(functionNoop);
  const modalCloseRef = useRef(functionNoop);

  const onDeactivateAccountClicked = () => {
    modalOpenRef.current();
  };

  const onAcceptClicked = async () => {
    setLoading(true);
    await onAcceptClick();
    await promiseDelay(6_000);
    setLoading(false);
    modalCloseRef.current();
  };

  const onDeclineClicked = () => {
    modalCloseRef.current();
  };

  return (
    <>
      <button onClick={onDeactivateAccountClicked} type='button' className='btn-bedrock-secondary'>
        Deactivate organization
      </button>
      <MiniModal
        openRef={modalOpenRef}
        closeRef={modalCloseRef}
        width='430px'
        subtitle={
          <div className='flex flex-col gap-2 text-bedrock-white'>
            <h3 className='text-neue-journey-medium-strong text-inherit'>We're sorry to see you go</h3>
            <div className='flex flex-col gap-1'>
              <span className='text-neue-journey-medium text-inherit'>
                If you deactivate organization, the organization's current subscription will be terminated and all of
                the members will lose access to all your data.
              </span>
              <span className='text-neue-journey-medium  text-inherit'>
                Are you sure you want to deactivate organization?
              </span>
            </div>
          </div>
        }
      >
        <div className={classNames('flex gap-2', { 'pointer-events-none': loading })}>
          <NeueJourneyButton type='button' onClick={onAcceptClicked} className='w-[50px]'>
            {!loading ? 'Yes' : <NeueJourneyLoadingSpinner size='16' />}
          </NeueJourneyButton>
          <Button type='button' size='regular' variant='secondary' label='No' onClick={onDeclineClicked} />
        </div>
      </MiniModal>
    </>
  );
};
